import { fetchCloseDocs } from '../../../api/orders'

// initial state
const state = {
  closeDocs: []
}

// getters
const getters = {
  closeDocs: state => state.closeDocs
}

// actions
const actions = {
  async fetchCloseDocs ({commit, state}) {
    const data = await fetchCloseDocs()
    commit('setCloseDocs', {closeDocs: data.orders})
  }
}

// mutations
const mutations = {
  setCloseDocs (state, {closeDocs}) {
    state.closeDocs = closeDocs
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/store/modules/closeDocs.js